import React from "react";
import classes from "../HomeScreen.module.css";
import { useMediaQuery, useTheme } from "@material-ui/core";
import { useHistory } from "react-router";
import PrimaryButton from "../../../components/Buttons/PrimaryButton";
import Utils from "../../../Utils";
import heroVideoMobile from "../../../assets/video/heroVideoMobile.webm";
import heroVideoDesktop from "../../../assets/video/heroVideoDesktop.webm";
import heroPoster from "../../../assets/images/Back-to-school.webp";
import heroPosterMobile from "../../../assets/images/Back-to-school-Reel.webp";
// import heroBanner from "../../../assets/images/homebanner.jpg";
// import heroBannerMobile from "../../../assets/images/homebannermobile.jpg";

function HeroSection() {
  const history = useHistory();
  const theme = useTheme();
  const isMobScreen = !useMediaQuery(theme.breakpoints.up("sm"));

  const createBookHandler = () => {
    Utils.createBook(history);
  };

  return (
    <div className={classes.heroImageContainer}>
      <video
        key={isMobScreen ? "mobile" : "desktop"}
        autoPlay
        muted
        loop
        playsInline
        poster={isMobScreen ? heroPosterMobile : heroPoster}
        src={isMobScreen ? heroVideoMobile : heroVideoDesktop}
      >
        Your browser does not support the video tag.
      </video>
      <div
        className={
          isMobScreen ? classes.createMobileButton : classes.createButton
        }
      >
        <PrimaryButton onClick={createBookHandler}>
          Get Started Now!
        </PrimaryButton>
      </div>
    </div>
  );
}

export default HeroSection;
